import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { FulfillmentContent } from './FulfillmentDashboardPage';
import SOGroupedFulfillmentView from './fulfillment/SOGroupedFulfillmentView';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';

/**
 * Production Fulfillment (New) — toggle between By SO (default) and By Item (legacy).
 */
export default function ProductionFulfillmentNewPage() {
  const [view, setView] = useState('by-so');
  return (
    <DashboardLayout>
      <Tabs value={view} onValueChange={setView} className="space-y-3">
        <TabsList>
          <TabsTrigger value="by-so" data-testid="tab-view-by-so">By Sales Order</TabsTrigger>
          <TabsTrigger value="by-item" data-testid="tab-view-by-item">By Item (legacy)</TabsTrigger>
        </TabsList>
        <TabsContent value="by-so" className="m-0">
          <SOGroupedFulfillmentView mode="production" />
        </TabsContent>
        <TabsContent value="by-item" className="m-0">
          <FulfillmentContent mode="ip" />
        </TabsContent>
      </Tabs>
    </DashboardLayout>
  );
}
